import { ENRICHMENT_CATEGORY_TYPE_LIVEVOTING, ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE, ENRICHMENT_CATEGORY_TYPE_VOTE } from 'common-data-handling';
import _ from 'lodash';
import React from 'react';
import { isVotingSessionOpen } from '../../../../../data/filters/voting/isVotingSessionOpen';
import { useLiveVotingSessions } from '../../../../../data/hooks/voting/useLiveVotingSessions';
import { EnrichmentPollOption } from './EnrichmentPollOption';
import { LiveVotingPollOption } from './LiveVotingPollOption';
import styles from './PollOptions.module.scss';

const POLL_CATEGORIES = [ENRICHMENT_CATEGORY_TYPE_VOTE, ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE, ENRICHMENT_CATEGORY_TYPE_LIVEVOTING];

export function PollOptions(props) {
    const { event, i18n } = props,
        hasOpenVotingSessions = useLiveVotingSessions(event.id, { filter: isVotingSessionOpen }).length > 0,
        pollEcats = _(event.enrichment_categories)
            .values()
            .filter((ecat) => _.includes(POLL_CATEGORIES, ecat.category))
            .value();

    if (!pollEcats.length && !event?.settings?.vote_url) return null;

    return (
        <div className={[styles.PollOptions, props.className].join(' ')} style={props.style}>
            {pollEcats.map((ecat) => (
                <EnrichmentPollOption key={ecat.category} ecat={ecat} event={event} i18n={i18n} hasOpenVotingSessions={hasOpenVotingSessions} />
            ))}
            <LiveVotingPollOption event={event} i18n={i18n} />
        </div>
    );
}
